module.exports = __webpack_public_path__ + "static/media/add-border.83d29092.svg";